import { lazy } from 'react';

const Login = lazy(() => import('./login'));
const SsoCallback = lazy(() => import('./sso-callback'));
const SsoIdpStartLogin = lazy(() => import('./sso-idp-start-login'));
const Verify = lazy(() => import('./verify'));
const SelectVerify = lazy(() => import('./select-verify'));
const ForgotPassword = lazy(() => import('./forgot-password'));

export {
  Login,
  Verify,
  SsoCallback,
  SelectVerify,
  ForgotPassword,
  SsoIdpStartLogin,
};
